import { createContext, useContext } from "react";

/**
 * Analytics scope: when a page id is set, every analytics hook reads the
 * page-scoped endpoints (`/analytics/v1/pages/{id}/*`) instead of the
 * whole-property ones (`/sites/{id}/*`). This powers Signals' "filter by page".
 *
 * Default is `null` (no page filter → whole property). Only Signals provides a
 * non-null value, so Today/Home keep their property-wide view unchanged.
 */
const AnalyticsPageScopeCtx = createContext<string | null>(null);

export const AnalyticsScopeProvider = AnalyticsPageScopeCtx.Provider;

/** The active page id to scope analytics to, or null for whole-property. */
export function useAnalyticsPageScope(): string | null {
  return useContext(AnalyticsPageScopeCtx);
}
